export const MonthlyIncome = {
  en: {
    'Monthly Income': 'Monthly Income',
    'Select Month': 'Select Month',
    Recalculate: 'Recalculate',
    'Recalculating...': 'Recalculating...',
    Till: 'Till',
    From: 'From',
    Filter: 'Filter',
    'Monthly Income Without Trainer Payouts':
      'Monthly Income Without Trainer Payouts',
    'No Data Provided': 'No Data Provided',
    'Year-month from and till must be selected':
      'Year-month from and till must be selected',
  },
  ru: {
    'Monthly Income': 'Месячный Доход',
    'Select Month': 'Выберите Месяц',
    Recalculate: 'Пересчитать',
    'Recalculating...': 'Пересчитывается...',
    Till: 'До',
    From: 'От',
    Filter: 'Фильтр',
    'Monthly Income Without Trainer Payouts':
      'Месячный Доход Без Выплат Тренерам',
    'No Data Provided': 'Нет Данных',
    'Year-month from and till must be selected':
      'Необходимо выбрать месяц "От" и "До"',
  },
  uk: {
    'Monthly Income': 'Місячний Дохід',
    'Select Month': 'Виберіть Місяць',
    Recalculate: 'Перерахувати',
    'Recalculating...': 'Перераховується...',
    Till: 'До',
    From: 'Від',
    Filter: 'Фільтр',
    'Monthly Income Without Trainer Payouts':
      'Місячний Дохід Без Виплат Тренерам',
    'No Data Provided': 'Немає Даних',
    'Year-month from and till must be selected':
      'Необхідно вибрати місяць "Від" та "До"',
  },
};
